<template>
  <v-dialog v-model="showVariablePopup" persistent>
    <v-btn flat icon slot="activator">
      <v-icon>preview</v-icon>
    </v-btn>
    <v-toolbar dense card>
      <div class="text-lg-left beez-bold ">
        Showing value of : {{ input.key }}
      </div>
      <v-spacer></v-spacer>
      <v-btn flat icon @click="showVariablePopup = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <form-generator :schema="convertToArray(input)" :readonly="true" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import FormGenerator from '@/components/common/form-generator/FormGenerator'

export default {
  name: 'DisplayVariableSchemaPopup',
  components: { FormGenerator },
  props: {
    input: {}
  },
  data() {
    return {
      showVariablePopup: false
    }
  },
  methods: {
    convertToArray(input) {
      let schema = []
      schema.push(input)
      return schema
    }
  }
}
</script>
